import * as React from 'react';

import Keynote56 from './Keynote56';

export const keynote56 = () => <Keynote56 />;

export default {
    title: 'Illustration|Keynote56',
    component: Keynote56,
    parameters: {
        notes: "`import Keynote56 from 'box-ui-elements/es/illustration/Keynote56';`",
    },
};
